// extracted by mini-css-extract-plugin
export default {"cls1":"VeloTimeline-Header_cls1__aB5cX","cls2":"VeloTimeline-Header_cls2__9QE61 VeloTimeline-Header_cls1__aB5cX"};